import React from 'react';
import CustomerEditPolicyBasicCoverageGrid from '../customer-basic-coverage/CustomerEditPolicyBasicCoverageGrid';

export interface ICustomerEditPolicyEndorsementGrid {
  customerId?: string;
  policyId?: string;
  policyEventId?: string;
  validationErrors?: any;
  tabIndex?: number;
}

const CustomerEditPolicyEndorsementGrid: React.FC<ICustomerEditPolicyEndorsementGrid> = (props) => {
  return (
      <CustomerEditPolicyBasicCoverageGrid
        {...props}
        isCoverages={false}
        validationErrors={props.validationErrors}
        tabIndex={props.tabIndex}
      />
  );
};

export default CustomerEditPolicyEndorsementGrid;